import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateComponent } from '../state-component.interface';
import { Usdm2Service } from '../../../../services/ai/usdm2.service';
import { Subscription } from 'rxjs';

type SingleElementInput = {
  name: string;
  code: string;
  subtype_uid: string;
  start_rule: string;
  end_rule: string;
  description: string;
  short_name: string;
};
type ElementsInput = {
  all_study_elements: SingleElementInput[];
};


@Component({
  selector: 'app-endpoints',
  imports: [],
  templateUrl: './elements.component.html',
  styleUrl: './elements.component.css'
})
export class ElementsComponent implements StateComponent, OnInit, OnDestroy {
  stateName = 'Elements';
  private usdmSub: Subscription | null = null;
  data: ElementsInput | null = null;

  constructor(private usdm: Usdm2Service) { }

  ngOnInit(): void {
    this.usdmSub = this.usdm.contentUpdate$.subscribe((item) => {
      if (this.usdm.currentState() == this.stateName && item && item.type === 'FinishResponse') {
        this.data = item.result as ElementsInput;
        this.usdm.signalStateCompletion(this.stateName);
      }
    });
  }

  ngOnDestroy(): void {
    this.usdmSub?.unsubscribe();
    this.usdmSub = null;
  }

}
